export default __webpack_public_path__ + "static/media/img_gas_phase_02.a059e2fe.png";